import React from 'react';

import type {
  CourseDefinitionQuizQuestionAnswerResponse,
  CourseSessionQuizQuestionAnswerResponse,
} from 'src/api/ProactApiClient';
import {RadioGroupBox} from 'src/design/atoms/RadioGroupBox';
import type {ISelectOption} from 'src/types/Form';

export interface SessionAnswerSingleChoiceProps {
  answers: CourseDefinitionQuizQuestionAnswerResponse[];
  sessionAnswers: CourseSessionQuizQuestionAnswerResponse[];
  onSessionAnswersChange: (
    answers: CourseSessionQuizQuestionAnswerResponse[]
  ) => void;
  disabled?: boolean;
  error?: boolean;
}
export const SessionAnswerSingleChoice: React.FC<
  SessionAnswerSingleChoiceProps
> = ({answers, sessionAnswers, onSessionAnswersChange, disabled, error}) => {
  function getAnswerOptions(
    answer: CourseDefinitionQuizQuestionAnswerResponse
  ) {
    return {
      id: answer.id,
      label: answer.text,
    } as ISelectOption;
  }
  const options = answers.map(answer => getAnswerOptions(answer));

  const values = sessionAnswers
    .filter(i => i.isSelected === true)
    .map(i => i.answerDefinitionId);
  const value = values.length > 0 ? String(values[0]) : undefined;

  const handleChangeCallback = (value: string): void => {
    onSessionAnswersChange(
      sessionAnswers.map(i => {
        return {...i, isSelected: String(i.answerDefinitionId) === value};
      })
    );
  };

  return (
    <RadioGroupBox
      label=""
      options={options}
      value={value}
      onChangeCallback={handleChangeCallback}
      disabled={disabled}
      error={error}
      orientation="vertical"
    />
  );
};
